export const HERO_SLIDER_SLIDE_CLASS = "hero-slider-slide";
export const MIN_SLIDE_DELAY_IN_MILLISECONDS = 1000;
